var should = require('./cjs/should');

var defaultProto = Object.prototype;
var defaultProperty = 'should';

//Expose api via `Object#should`.
try {
  var prevShould = should.extend(defaultProperty, defaultProto);
  should._prevShould = prevShould;
} catch(e) {
  //ignore errors
}

module.exports = should;



//////////////////
// WEBPACK FOOTER
// ./~/should/index.js
// module id = 335
// module chunks = 1